import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { getUserData } from '../../../Redux/slices/user';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../_helpers/_methods';
import Role from './Role';

function RoleChanger({ activeRole, changeActiveRole }) {
  const roles = useSelector((state) => state.user?.user?.role);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRoleChange = async (title) => {
    try {
      await fetchWrapper.post('/switch-role/', {
        role: title
      });
      changeActiveRole(title);
      toast.success(`Successfully changed role to ${title}`);
      dispatch(getUserData());
      navigate('/admin');
    } catch (err) {
      ErrorMessageHandler(err);
    }
  };

  return (
    <StyledRoleChanger>
      <span className="d-block small">Roles:</span>
      <div className="roleWrapper">
        {roles.map((role) => (
          <Role
            title={role.title}
            id={role.id}
            key={role.key}
            activeRole={activeRole}
            handleRoleChange={handleRoleChange}
          />
        ))}
      </div>
    </StyledRoleChanger>
  );
}

export default RoleChanger;

const StyledRoleChanger = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 10px;
  padding: 5px;
  .roleWrapper {
    display: flex;
    max-width: 224px;
    padding: 4px;
    overflow-x: auto;
  }
`;
